import { Box, Button, Link, makeStyles } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";

import {
  GrantsBoiler,
  FinanceBoiler,
  GrantsSolar,
  FinanceSolar,
  GrantsfinanceBoilerType,
  GrantsfinanceSolarType
} from "./FinancalSupports.constants";
import { Quote } from "../../../../api/Quote/Quote";
import { useBreakpoint } from "../../../../hooks/useBreakpoint";

export const FinancalSupports = ({
  grants = GrantsBoiler,
  finance = FinanceBoiler,
  grantsSolar = GrantsSolar,
  financeSolar = FinanceSolar,
  quote
}: {
  grants?: GrantsfinanceBoilerType[];
  finance?: GrantsfinanceBoilerType[];
  grantsSolar?: GrantsfinanceSolarType[];
  financeSolar?: GrantsfinanceSolarType[];
  quote: Quote;
}) => {
  const classes = FinancalSupportsStyles();
  const { isMoreThanSm } = useBreakpoint();
  return (
    <Box className={classes.container}>
      <Box className={classes.header} color="#160337">
        <span className={classes.spanTitle}>Financial supports</span> available to you
      </Box>
      <Box className={classes.subTitle}>
        If you are eligible for SEAI grants and/or Finance will we manage the process for you
      </Box>
      {quote.type.includes("Solar") ? (
        <Box className={classes.wrapper}>
          <Box className={classes.box}>
            <Box className={classes.boxClipPath}>
              <Box className={classes.boxContent}>
                <Box>
                  {grantsSolar.map((item, index) => {
                    return (
                      <Box key={index}>
                        <Box
                          height={isMoreThanSm ? "166px" : "149px"}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <img className={classes.img} src={item.src} alt="text" />
                        </Box>
                        <Box className={classes.title}>{item.title}</Box>
                        <Box className={classes.content}>{item.content}</Box>
                        <Box paddingX={6} paddingBottom={isMoreThanSm ? "60px" : "40px"}>
                          {item.list.map((items, index) => {
                            return (
                              <Box paddingY={1} textAlign="left" display="flex" alignItems="center" key={index}>
                                <CheckIcon className={classes.span} />
                                <Box className={classes.list} paddingLeft={2}>
                                  {items}
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={classes.box}>
            <Box className={classes.boxClipPath}>
              <Box className={classes.boxContent}>
                <Box>
                  {financeSolar.map((item, index) => {
                    return (
                      <Box key={index}>
                        <Box
                          height={isMoreThanSm ? "166px" : "149px"}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <img className={classes.img} src={item.src} alt="text" />
                        </Box>
                        <Box className={classes.title}>{item.title}</Box>
                        <Box className={classes.content}>{item.content}</Box>
                        <Box paddingX={6} paddingBottom={isMoreThanSm ? "60px" : "40px"}>
                          {item.list.map((items, index) => {
                            return (
                              <Box paddingY={1} textAlign="left" display="flex" alignItems="center" key={index}>
                                <CheckIcon className={classes.span} />
                                <Box className={classes.list} paddingLeft={2}>
                                  {items}
                                </Box>
                              </Box>
                            );
                          })}
                        </Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
        </Box>
      ) : (
        <Box className={classes.wrapper}>
          <Box className={classes.box}>
            <Box className={classes.boxClipPath}>
              <Box className={classes.boxContent}>
                <Box>
                  {grants.map((item, index) => {
                    return (
                      <Box key={index}>
                        <Box
                          height={isMoreThanSm ? "166px" : "129px"}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <img className={classes.img} src={item.src} alt="text" />
                        </Box>
                        <Box className={classes.title}>{item.title}</Box>
                        <Box className={classes.content}>{item.content}</Box>
                      </Box>
                    );
                  })}
                </Box>
              </Box>
            </Box>
          </Box>
          <Box className={classes.box}>
            <Box className={classes.boxClipPath}>
              <Box className={classes.boxContent}>
                <Box>
                  {finance.map((item, index) => {
                    return (
                      <Box key={index}>
                        <Box
                          height={isMoreThanSm ? "166px" : "129px"}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                        >
                          <img className={classes.img} src={item.src} alt="text" />
                        </Box>
                        <Box className={classes.title}>{item.title}</Box>
                        <Box className={classes.content}>{item.content}</Box>
                      </Box>
                    );
                  })}
                </Box>
                {!isMoreThanSm && (
                  <Box>
                    <Link
                      href={
                        quote.type.includes("Solar")
                          ? "https://greenloans.financeireland.ie/calculator?supplier=A1D2"
                          : "https://apply.flexifi.com/s/quote?src=0010Y00001Tl4JMQAZ&toURL=Quote"
                      }
                      target="__blank"
                    >
                      <Button className={classes.buttonInside}>Calculate Finance</Button>
                    </Link>
                  </Box>
                )}
              </Box>
            </Box>
          </Box>
        </Box>
      )}
      {(quote.type.includes("Solar") || (isMoreThanSm && quote.type.includes("Boiler"))) && (
        <Box>
          <Link
            href={
              quote.type.includes("Solar")
                ? "https://greenloans.financeireland.ie/calculator?supplier=A1D2"
                : "https://apply.flexifi.com/s/quote?src=0010Y00001Tl4JMQAZ&toURL=Quote"
            }
            target="__blank"
          >
            <Button className={classes.button}>Calculate Finance</Button>
          </Link>
        </Box>
      )}
    </Box>
  );
};

const FinancalSupportsStyles = makeStyles((theme) => ({
  container: {
    "width": 930,
    "margin": "auto",
    "textAlign": "center",
    "marginTop": 100,
    "marginBottom": "150px",
    "fontFamily": "Axiforma, serif, sans-serf !important",
    [theme.breakpoints.down("sm")]: {
      width: 340,
      fontFamily: "Axiforma, serif, sans-serf !important",
      marginBottom: "60px"
    },
    "& a": {
      "textDecoration": "none",
      "&:hover": {
        textDecoration: "none"
      }
    }
  },
  buttonInside: {
    "backgroundColor": "#160337",
    "borderRadius": "25px",
    "fontSize": "14px",
    "color": "#fff",
    "width": "250px",
    "height": "50px",
    "textDecoration": "none",
    "&:hover": {
      backgroundColor: "#160337"
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "10px",
      marginBottom: "60px"
    }
  },
  button: {
    "backgroundColor": "#160337",
    "borderRadius": "25px",
    "fontSize": "14px",
    "color": "#fff",
    "textDecoration": "none",
    "width": "250px",
    "height": "50px",
    "& span": {
      fontSize: "14px",
      color: "#fff",
      textDecoration: "none"
    },
    "&:hover": {
      "backgroundColor": "#160337",
      "& span": {
        fontSize: "14px",
        color: "#fff",
        textDecoration: "none"
      }
    },
    [theme.breakpoints.down("sm")]: {
      marginTop: "30px"
    }
  },
  box: {
    width: 430,
    marginBottom: 100,
    borderRadius: 4,
    position: "relative",
    filter: "drop-shadow(0px 5px 15px rgba(0, 0, 0, 0.07)) drop-shadow(0px 15px 15px rgba(50, 50, 93, 0.1))",
    [theme.breakpoints.down("sm")]: {
      marginBottom: "30px"
    }
  },
  boxClipPath: {
    filter: "url(#round)"
  },
  boxContent: {
    background: "#fff",
    clipPath: "polygon(calc(100% - 50px) 0, calc(100% - 50px) 50px, 100% 50px, 100% 100%, 0 100%, 0 0)",
    [theme.breakpoints.down("sm")]: {
      clipPath: "polygon(calc(100% - 40px) 0, calc(100% - 40px) 40px, 100% 40px, 100% 100%, 0 100%, 0 0)"
    }
  },
  header: {
    fontSize: 28,
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: 20,
      marginBottom: "42px"
    }
  },
  spanTitle: {
    color: "#f7815c",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
      display: "block"
    }
  },
  span: {
    color: "#f7815c"
  },
  subTitle: {
    fontSize: 16,
    marginTop: 20,
    marginBottom: 50,
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  },
  wrapper: {
    display: "flex",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      "display": "flex",
      "flex-wrap": "wrap",
      "textAlign": "center"
    }
  },
  img: {
    objectFit: "cover",
    maxHeight: "68px"
  },
  title: {
    fontSize: 28,
    fontWeight: 500,
    [theme.breakpoints.down("sm")]: {
      fontSize: 24
    }
  },
  content: {
    padding: 50,
    paddingTop: 20,
    fontSize: 14,
    [theme.breakpoints.down("sm")]: {
      fontSize: 12,
      paddingTop: 20,
      padding: 30
    }
  },
  list: {
    fontSize: 14,
    [theme.breakpoints.down("sm")]: {
      fontSize: 12
    }
  }
}));
